import React from "react";
import "./Sidebar.css";
import { Icon } from "@shopify/polaris";
import { ExitIcon, LayoutSidebarLeftIcon } from "@shopify/polaris-icons";

import SidebarIcon from "./SidebarIcon";
import useMenuModel from "./useMenuModel";
import { UserAuth } from "../../context/AuthContext";
import { useBranch } from "../../context/BranchContext";

// Classic design: a 50px icon rail with hover flyout submenus.
function Sidebar() {
  const { setNavLayout, signOutUser } = UserAuth();
  const { branch, isLargoPlazo } = useBranch();
  const items = useMenuModel();

  const signOut = () => signOutUser();

  return (
    <div className="main_sidebar_container">
      {branch && (
        <div style={{ textAlign: "center", padding: "8px 4px 0", fontSize: "0.6rem", color: "#999", lineHeight: 1.2 }}>
          {isLargoPlazo ? "LP" : "CP"}
          <div style={{ fontSize: "0.5rem" }}>{branch.name?.substring(0, 12)}</div>
        </div>
      )}
      {items.map((item) => {
        const submenuLinks = item.links.map((sub) => ({
          title: sub.label,
          url: sub.route,
          // Submenu rows show their own single count (no rollup).
          badge: sub.badge,
        }));

        const submenu = item.submenu && submenuLinks.length > 0
          ? { title: item.label, links: submenuLinks }
          : null;

        return (
          <SidebarIcon
            key={item.key}
            icon={<Icon source={item.icon} />}
            to={item.route}
            submenu={submenu}
            // Parent icon shows its own count + sum of all visible submenu counts.
            badge={item.badge}
          />
        );
      })}
      <div title="Probar nuevo diseño del menú">
        <SidebarIcon icon={<Icon source={LayoutSidebarLeftIcon} />} onClick={() => setNavLayout("polaris")} />
      </div>
      <SidebarIcon icon={<Icon source={ExitIcon} />} onClick={signOut} />
    </div>
  );
}

export default Sidebar;
